import { BaseEvent } from "@fideus/analytics";

export class MaintenancePageLoadedEvent extends BaseEvent<object> {
  override readonly "detail-type" = "MaintenancePageLoaded" as const;

  constructor() {
    super({});
  }
}
